import { createStyles, rem } from "@mantine/core";

const useStyles = createStyles((theme) => ({
  cardsParentBox: {
    width: "100%",
    paddingInline: "6rem",
    paddingBottom: "4rem",
    "@media (max-width: 768px)": {
      paddingInline: "2rem",
    },
    "@media (max-width: 430px)": {
      paddingInline: "1rem",
    },
  },

  cardcontainer: {
    width: "57%",
    margin: "auto",
  },
  centered: {
    alignItems: "center",
    textAlign: "center",
  },
  title: {
    fontSize: rem(34),
    fontWeight: 700,
    fontFamily: "Inter",
    marginBottom: rem(10),
  },
  description: {
    fontSize: rem(20),
    fontWeight: 400,
    fontFamily: "Inter",
    color: "#979797",
    // marginBottom: rem(50),
  },
  logo: {
    marginTop: rem(100),
    marginBottom: rem(40),
  },
  back: {
    position: "absolute",
    top: rem(50),
    // left: rem(50),
    fontSize: rem(16),
    fontFamily: "Inter",
    fontWeight: 500,
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    width: "100%",
    padding: "0 3rem",
  },
  monthlyAndYearlyTab: {
    "& .mantine-Tabs-tabsList": {
      marginBlock: "40px",
      width: "fit-content",
      backgroundColor: "#171717",
      marginInline: "auto",
      borderRadius: "28px",
      padding: "4px",
      "& .mantine-Tabs-tab": {
        color: "#FFFFFF",
        fontFamily: "Inter",
        fontSize: "20px",
        fontWeight: "400",
        padding: "14px 30px",
        borderRadius: "28px",
        "&:hover": {
          backgroundColor: "#171717",
          color: "#FFFFFF",
          opacity: 0.9,
        },
        "&[data-active]": {
          backgroundColor: "#FFAF4A",
          "&:hover": {
            backgroundColor: "#FFAF4A",
            color: "#FFFFFF",
            opacity: "unset",
          },
        },
      },
    },
  },
  comingSoonText: {
    fontFamily: "Inter",
    fontSize: "40px",
    fontWeight: "400",
    lineHeight: "50px",
    textAlign: "left",
    marginBottom: "30px",
    "@media (max-width: 768px)": {
      fontSize: "30px",
      lineHeight: "30px",
    },
  },
}));

export default useStyles;
